<template>
  <div>
    <v-card-text>
      <v-form ref="form" lazy-validation>
        <v-autocomplete
          v-if="this.MeasuresOptions !== null"
          v-model="selectedMeasures"
          :items="translateMeasures"
          chips
          clearable
          deletable-chips
          :label="this.$i18n.tc('select_modality_of_measures', 0)"
          :rules="rules"
          @change="measuresChoice()"
        >
        </v-autocomplete>
      </v-form>
      <v-select
        v-if="
          this.standPopOptions !== null &&
            ['standardised_mortality_rate_by_age','standardised_mortality_rate_by_age_and_sexe'].includes(this.selectedMeasures)
        "
        v-model="selectedStandPop"
        :items="translateStandPop"
        :label="this.$i18n.tc('select_standard_population', 0)"
        @change="measuresChoice()"
        dense
      >
      </v-select>
      <div v-if="['standardised_mortality_rate_by_age','standardised_mortality_rate_by_age_and_sexe'].includes(this.selectedMeasures)">
        {{ this.$t("standard_population") + ":" }}
        <a
          :href="this.$t(this.selectedStandPop + '.src')"
          :title="this.$t(this.selectedStandPop + '.src')"
          target="_blank"
          class="warning--text"
          >{{ this.$t(this.selectedStandPop + ".description") }}
          <v-icon small color="warning">{{ mdiOpenInNew }}</v-icon>
        </a>
      </div>
    </v-card-text>
  </div>
</template>

<script>
import { mdiOpenInNew } from "@mdi/js";
import axios from "axios";
export default {
  name: "MeasuresForm",
  components: {},
  data: function() {
    return {
      MeasuresOptions: [],
      standPopOptions: [],
      UnavailableMeasuresOptions: [],
      selectedMeasures: "raw_number_of_death",
      selectedStandPop: null,
      error: null,
      rules: [value => !!value || this.$t("mandatory")],
      mdiOpenInNew: mdiOpenInNew
    };
  },
  computed: {
    isValid: function() {
      return this.selectedMeasures !== null;
    },
    translateMeasures: function() {
      const val = this;
      const res = this.MeasuresOptions.map(function(e) {
        return {
          value: e,
          text: val.$i18n.tc(e, 0),
          disabled: val.UnavailableMeasuresOptions.includes(e)
        };
      });
      return res;
    },
    translateStandPop: function() {
      const val = this;
      const res = this.standPopOptions.map(function(e) {
        return {
          value: e,
          text: val.$i18n.t(e).label
        };
      });
      return res;
    }
  },
  methods: {
    availableMeasures: function() {
      this.error = false;
      axios
        .get("bcmd/r/measures", {
          params: {}
        })
        .then(response => {
          this.MeasuresOptions = response.data;
        })
        .catch(() => {
          this.error = true;
        });
      axios
        .get("bcmd/r/unavailableMeasures", {
          params: {}
        })
        .then(response => {
          this.UnavailableMeasuresOptions = response.data;
        })
        .catch(() => {
          this.error = true;
        });
    },
    availableStandPop: function() {
      this.error = false;
      axios
        .get("bcmd/r/standpop", {
          params: {}
        })
        .then(response => {
          this.standPopOptions = response.data;
          this.selectedStandPop = response.data[0];
        })
        .catch(() => {
          this.error = true;
        });
    },
    measuresChoice: function() {
      this.$emit("update-measures", {
        selectedMeasures: this.selectedMeasures,
        selectedStandPop: this.selectedStandPop,
        valid: this.isValid
      });
      return true;
    }
  },
  beforeMount() {
    this.availableMeasures();
    this.availableStandPop();
  }
};
</script>
